.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-inline-size: var(--field-max);
}

.label {
  display: flex;
  gap: var(--space-4);
  align-items: center;
  justify-content: space-between;
  min-block-size: var(--control-sm);
  color: var(--color-text);
  font-size: var(--text-md);
  cursor: default;
}

.text {
  font-weight: var(--weight-medium);
}

.track {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  inline-size: calc(var(--icon-md) * 1.8);
  block-size: var(--icon-md);
  padding: calc(var(--space-1) / 2);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background: var(--color-surface-sunken);
  transition:
    background-color var(--duration-fast) ease,
    border-color var(--duration-fast) ease;
}

.track[data-checked] {
  border-color: var(--color-accent);
  background: var(--color-accent);
}

.track[data-disabled] {
  border-color: var(--color-border);
  opacity: 0.6;
}

.track[aria-busy="true"] {
  cursor: progress;
}

.track:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.thumb {
  inline-size: calc(var(--icon-md) - var(--space-1) - var(--border-width) * 2);
  block-size: calc(var(--icon-md) - var(--space-1) - var(--border-width) * 2);
  border-radius: var(--radius-full);
  background: var(--color-text-subtle);
  transition:
    transform var(--duration-fast) var(--easing-standard),
    background-color var(--duration-fast) ease;
}

.thumb[data-checked] {
  background: var(--color-accent-contrast);
  transform: translateX(calc(var(--icon-md) * 0.8));
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}
